module.exports = __webpack_public_path__ + "img/011.bd0e1c83.jpg";